/**
 * Route for `help-center`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { HelpCenterPage } from "../features/help-center/HelpCenterPage";

export const helpCenterRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/help-center",
	component: HelpCenterPage,
});

export default helpCenterRoute;
